import ValueExpiring from '@/teams/dashboard/ValueExpiring';
import CreateReports from '@/teams/reports/create-reports';
import ReportsLanding from '@/teams/reports/reports-landing';
import RevenueGoals from '@/teams/partials/RevenueGoals';
import CreativePopper from '@/orders/partials/CreativePopper';
import ShareOrderItems from '@/orders/partials/ShareOrderItems';

Vue.component('team-dashboard', {
    components: {
        CreativePopper,
        CreateReports,
        ValueExpiring,
        ReportsLanding,
        ShareOrderItems,
        RevenueGoals,
    },
});
